import { API_BASE_URL, WS_BASE_URL } from "../utils/constants";

const GAME_API_BASE_URL = (
  process.env.REACT_APP_FRONTEND_API_URL ||
  process.env.VITE_FRONTEND_API_URL ||
  `${API_BASE_URL}/api/frontend/`
).replace(/\/+$/, "");

export function resolveWebSocketUrl(path) {
  if (!path) {
    return null;
  }

  if (/^wss?:\/\//i.test(path)) {
    return path;
  }

  const wsBaseFromEnv =
    process.env.REACT_APP_WS_BASE_URL || process.env.VITE_WS_URL || WS_BASE_URL;
  if (wsBaseFromEnv) {
    return `${wsBaseFromEnv.replace(/\/+$/, "")}${path}`;
  }

  if (typeof window !== "undefined") {
    const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    return `${protocol}//${window.location.host}${path}`;
  }

  return path;
}

export function resolveWebSocketFallbackUrls(path) {
  const primaryUrl = resolveWebSocketUrl(path);
  if (!primaryUrl) {
    return [];
  }

  const urls = [primaryUrl];
  try {
    const parsedUrl = new URL(primaryUrl);
    if (parsedUrl.hostname === "localhost") {
      parsedUrl.hostname = "127.0.0.1";
      urls.push(parsedUrl.toString());
    } else if (parsedUrl.hostname === "127.0.0.1") {
      parsedUrl.hostname = "localhost";
      urls.push(parsedUrl.toString());
    }
  } catch {
    return urls;
  }

  return Array.from(new Set(urls));
}

export async function joinGame(slug) {
  const res = await fetch(`${GAME_API_BASE_URL}/game/join/${slug}/`);
  if (!res.ok) throw new Error("Impossible de rejoindre la partie");
  return res.json();
}
